
export const FETCH_EWO_DISCRIPENCY_REQUEST = "FETCH_EWO_DISCRIPENCY_REQUEST";
export const FETCH_EWO_DISCRIPENCY_SUCCESS = "FETCH_EWO_DISCRIPENCY_SUCCESS";
export const FETCH_EWO_DISCRIPENCY_FAILURE = "FETCH_EWO_DISCRIPENCY_FAILURE";

export const FETCH_IWO_WITHOUT_EWO_REQUEST  = "FETCH_IWO_WITHOUT_EWO_REQUEST";
export const FETCH_IWO_WITHOUT_EWO_SUCCESS  = "FETCH_IWO_WITHOUT_EWO_SUCCESS";
export const FETCH_IWO_WITHOUT_EWO_FAILURE  = "FETCH_IWO_WITHOUT_EWO_FAILURE";

export const FETCH_EWO_WITHOUT_INVOICE_REQUEST = "FETCH_EWO_WITHOUT_INVOICE_REQUEST";
export const FETCH_EWO_WITHOUT_INVOICE_SUCCESS  = "FETCH_EWO_WITHOUT_INVOICE_SUCCESS";
export const FETCH_EWO_WITHOUT_INVOICE_FAILURE  = "FETCH_EWO_WITHOUT_INVOICE_FAILURE";